// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container .roles-table[data-v-37039a8c] {\n  margin-top: 30px;\n}\n.app-container .permission-tree[data-v-37039a8c] {\n  margin-bottom: 30px;\n}", ""]);
// Exports
module.exports = exports;
